// Theme registry. Each industry's tokens.js is registered here, and its
// CSS-variable surface is side-effect-imported so the bundle includes it
// regardless of which industry boots. ThemeProvider flips the
// data-industry attribute and the right `:root[data-industry="x"]` block
// activates at runtime — no rebuild, no remount.
import './_base/vars.scss';
import './demo/vars.scss';
import './grocery/vars.scss';
import './grocery/app-mobile.scss';
import './fish/vars.scss';
import './fish/app-mobile.scss';
import './meat/vars.scss';
import './meat/app-mobile.scss';
import './restaurant/vars.scss';
import './restaurant/app-mobile.scss';
import './publication/vars.scss';
import './pet/vars.scss';
import './pet/app-mobile.scss';
import './coffee/vars.scss';
import './coffee/app-mobile.scss';
import { baseTokens } from './_base/tokens.js';
import { demoTokens } from './demo/tokens.js';
import { groceryTokens } from './grocery/tokens.js';
import { fishTokens } from './fish/tokens.js';
import { meatTokens } from './meat/tokens.js';
import { restaurantTokens } from './restaurant/tokens.js';
import { publicationTokens } from './publication/tokens.js';
import { petTokens } from './pet/tokens.js';
import { coffeeTokens } from './coffee/tokens.js';

export const themes = {
  default: baseTokens,
  demo: demoTokens,
  grocery: groceryTokens,
  fish: fishTokens,
  meat: meatTokens,
  restaurant: restaurantTokens,
  publication: publicationTokens,
  pet: petTokens,
  coffee: coffeeTokens,
};
